export default __webpack_public_path__ + "static/media/guest_01_renato_carvalho.4bd86bbc.png";